import { useState, useEffect } from 'react';

const useImageValidator = (source: string) => {
    const [isValid, setIsValid] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;
        const image = new Image();
        image.src = source;

        const handleLoad = () => {
            if (isMounted) {
                setIsValid(true);
                setIsLoading(false);
            }
        };

        const handleError = () => {
            if (isMounted) {
                setIsValid(false);
                setIsLoading(false);
            }
        };

        image.addEventListener('load', handleLoad);
        image.addEventListener('error', handleError);

        return () => {
            isMounted = false;
            image.removeEventListener('load', handleLoad);
            image.removeEventListener('error', handleError);
        };
    }, [source]);

    return { isValid, isLoading };
};

export default useImageValidator;
